// extracted by mini-css-extract-plugin
export default {"menu":"DotMenu_menu__9amFB"};